import { useMemo } from "react"

import { string } from "prop-types"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { FileIcon, PersonRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { CardWithThumbnail } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { ModulesInfo } from "../../constants/modules"

import * as Styled from "./DocumentListItem.styled"

export const DocumentListItem = (props) => {
    const {
        document,
        documentTypes,
        onClick,
        onMouseEnter,
        onMouseLeave,
        menuConfig,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const hasThumbnail = useMemo(() => {
        return document?.thumbnail && !document?.mime_type?.includes("tiff")
    }, [document])

    const thumbnail = useMemo(() => {
        if (hasThumbnail) {
            return <Styled.Thumbnail src={document.thumbnail} alt={document.filename} />
        } else {
            const fileParts = document.file ? document.filename.split(".") : []
            const extension = fileParts.length >= 2 ? fileParts.pop() : ""
            return <FileIcon extension={extension} />
        }
    }, [document, hasThumbnail])

    const documentTypeIcon = useMemo(() => {
        const type = documentTypes.find(type => type.name === document.document_type)
        return type?.icon ? <Styled.TypeIcon src={type.icon} alt={type.name} /> : null
    }, [document.document_type, documentTypes])

    const AttachmentIcon = useMemo(() => {
        return ModulesInfo[document.attached_object_content_type ?? document.linear_location_type.toLowerCase()]?.icon
    }, [document])

    return (
        <CardWithThumbnail
            title={document.filename}
            date={new Date(document.date)}
            secondaryIcon={PersonRoundedIcon}
            secondaryText={document.created_by}
            chips={[
                {
                    icon: AttachmentIcon && <AttachmentIcon />,
                    label: t(I18N_NAMESPACE, ModulesInfo[document.attached_object_content_type ?? document.linear_location_type.toLowerCase()]?.labelKey),
                },
                {
                    icon: documentTypeIcon,
                    label: document.document_type,
                },
            ]}
            menuConfig={menuConfig}
            onClick={() => onClick(document)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <Styled.ThumbnailContainer hasThumbnail={hasThumbnail}>
                {thumbnail}
            </Styled.ThumbnailContainer>
        </CardWithThumbnail>
    )
}

DocumentListItem.propTypes = {
    document: PropTypes.document.isRequired,
    documentTypes: PropTypes.arrayOf(PropTypes.shape({
        name: string.isRequired,
        icon: string,
    })).isRequired,
    parentIcon: PropTypes.node,
    onClick: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onMouseEnter: PropTypes.func,
    menuConfig: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string.isRequired,
        icon: PropTypes.node,
        props: PropTypes.object,
    })),
}